export default [
  {
    path: '/revenue',
    name: 'RevenueSummary',
    component: () => import(/* webpackChunkName: "payments" */ '@/views/payment/Summary.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'PaymentListCreate',
      requireAuth: true,
      requireAccount: true,
      requireRevenue: true,
      title: 'Resumen de ingresos'
    }
  },
  {
    path: '/payments/:id',
    name: 'PaymentRetrieve',
    component: () => import(/* webpackChunkName: "payments" */ '@/views/payment/PaymentRetrieve.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'PaymentListCreate',
      requireAuth: true,
      requireAccount: true,
      title: 'Detalles de pagos'
    }
  },
  {
    path: '/payments',
    name: 'PaymentListCreate',
    component: () => import(/* webpackChunkName: "payments" */ '@/views/payment/PaymentListCreate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'PaymentListCreate',
      requireAuth: true,
      requireAccount: true,
      title: 'Pagos'
    }
  },
  {
    path: '/receivables',
    name: 'Receivables',
    component: () => import(/* webpackChunkName: "payments" */ '@/views/payment/Overview.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'PaymentListCreate',
      requireAuth: true,
      requireAccount: true,
      legacyTitle: 'Cuentas por cobrar',
      title: 'Análisis de cuentas por cobrar'
    }
  },
  {
    path: '/receivables/reminders',
    name: 'ReminderList',
    component: () => import(/* webpackChunkName: "payments" */ '@/views/payment/ReminderList.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'PaymentListCreate',
      requireAuth: true,
      requireAccount: true,
      legacyTitle: 'Recordatorios de pago',
      title: 'Recordatorios'
    }
  },
  {
    path: '/receivables/rules',
    name: 'RuleViewSet',
    component: () => import(/* webpackChunkName: "payments" */ '@/views/payment/RuleViewSet.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'PaymentListCreate',
      requireAuth: true,
      requireAccount: true,
      legacyTitle: 'Reglas de recordatorios de pago',
      title: 'Reglas de envío'
    }
  }
]